import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["action"]

  // to use in pair with stimulus-hotkeys, as the argument is not an "Event" object
  showFromHotkeys(dialogId) {
    const dialog = document.getElementById(dialogId)
    this.#showDialog(dialog)
  }

  show(event) {
    if (this.originalClick != true) {
      event.preventDefault()
      event.stopPropagation()
      this.#showDialog(document.getElementById(event.params.id))
      document.body.classList.add("no-scroll")
    }
  }

  #showDialog(dialog) {
    dialog.showModal()
    this.dispatch("show")
  }

  close(event) {
    const dialog = event.target.closest("dialog") || event.currentTarget.closest("dialog")
    dialog.close()
    document.body.classList.remove("no-scroll")
  }

  backdropClose(event) {
    if (event.target === event.currentTarget) {
      this.close(event)
    }
  }

  forceAction() {
    this.originalClick = true
    this.actionTarget.click()
  }

  closeOnEscape(event) {
    event.preventDefault()
    this.close(event)
  }
}
